import React from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';

export interface TextProps extends TypographyProps {}

export const Text: React.FC<TextProps> = props => {
  const modifiedProps: TextProps = {
    ...props,
    color: props.color ?? 'textSecondary'
  };

  return <Typography {...modifiedProps} />;
};
